const prefix = "@@alerts/"
const actionTypes = {
    GET_USERS_START: `${prefix}GET_USERS_START`,
    GET_USERS_SUCCESS: `${prefix}GET_USERS_SUCCESS`,
    GET_USERS_FAIL: `${prefix}GET_USERS_FAIL`,

    GET_ALERT_START: `${prefix}GET_ALERT_START`,
    GET_ALERT_SUCCESS: `${prefix}GET_ALERT_SUCCESS`,
    GET_ALERT_FAIL: `${prefix}GET_ALERT_FAIL`,

    GET_ALERT_GROUPS_START: `${prefix}GET_ALERT_GROUPS_START`,
    GET_ALERT_GROUPS_SUCCESS: `${prefix}GET_ALERT_GROUPS_SUCCESS`,
    GET_ALERT_GROUPS_FAIL: `${prefix}GET_ALERT_GROUPS_FAIL`,

    GET_SAVED_SEARCH_START: `${prefix}GET_SAVED_SEARCH_START`,
    GET_SAVED_SEARCH_SUCCESS: `${prefix}GET_SAVED_SEARCH_SUCCESS`,
    GET_SAVED_SEARCH_FAIL: `${prefix}GET_SAVED_SEARCH_FAIL`,

    POST_SAVED_SEARCH_START: `${prefix}POST_SAVED_SEARCH_START`,
    POST_SAVED_SEARCH_SUCCESS: `${prefix}POST_SAVED_SEARCH_SUCCESS`,
    POST_SAVED_SEARCH_FAIL: `${prefix}POST_SAVED_SEARCH_FAIL`,

    PATCH_SAVED_SEARCH_START: `${prefix}PATCH_SAVED_SEARCH_START`,
    PATCH_SAVED_SEARCH_SUCCESS: `${prefix}PATCH_SAVED_SEARCH_SUCCESS`,
    PATCH_SAVED_SEARCH_FAIL: `${prefix}PATCH_SAVED_SEARCH_FAIL`,

    GET_SAVED_SEARCH_ESTIMATED_COUNT_START: `${prefix}GET_SAVED_SEARCH_ESTIMATED_COUNT_START`,
    GET_SAVED_SEARCH_ESTIMATED_COUNT_SUCCESS: `${prefix}GET_SAVED_SEARCH_ESTIMATED_COUNT_SUCCESS`,
    GET_SAVED_SEARCH_ESTIMATED_COUNT_FAIL: `${prefix}GET_SAVED_SEARCH_ESTIMATED_COUNT_FAIL`,

    GET_ALERT_BY_SAVED_SEARCH_START: `${prefix}GET_ALERT_BY_SAVED_SEARCH_START`,
    GET_ALERT_BY_SAVED_SEARCH_SUCCESS: `${prefix}GET_ALERT_BY_SAVED_SEARCH_SUCCESS`,
    GET_ALERT_BY_SAVED_SEARCH_FAIL: `${prefix}GET_ALERT_BY_SAVED_SEARCH_FAIL`,

    GET_ALERT_BY_DATUM_ID_START: `${prefix}GET_ALERT_BY_DATUM_ID_START`,
    GET_ALERT_BY_DATUM_ID_SUCCESS: `${prefix}GET_ALERT_BY_DATUM_ID_SUCCESS`,
    GET_ALERT_BY_DATUM_ID_FAIL: `${prefix}GET_ALERT_BY_DATUM_ID_FAIL`,

    POST_ALERT_START: `${prefix}POST_ALERT_START`,
    POST_ALERT_SUCCESS: `${prefix}POST_ALERT_SUCCESS`,
    POST_ALERT_FAIL: `${prefix}POST_ALERT_FAIL`,

    PATCH_ALERT_START: `${prefix}PATCH_ALERT_START`,
    PATCH_ALERT_SUCCESS: `${prefix}PATCH_ALERT_SUCCESS`,
    PATCH_ALERT_FAIL: `${prefix}PATCH_ALERT_FAIL`,

    DELETE_ALERT_START: `${prefix}DELETE_ALERT_START`,
    DELETE_ALERT_SUCCESS: `${prefix}DELETE_ALERT_SUCCESS`,
    DELETE_ALERT_FAIL: `${prefix}DELETE_ALERT_FAIL`,

    POST_ALERT_GROUPS_START: `${prefix}POST_ALERT_GROUPS_START`,
    POST_ALERT_GROUPS_SUCCESS: `${prefix}POST_ALERT_GROUPS_SUCCESS`,
    POST_ALERT_GROUPS_FAIL: `${prefix}POST_ALERT_GROUPS_FAIL`,

    PATCH_ALERT_GROUPS_START: `${prefix}PATCH_ALERT_GROUPS_START`,
    PATCH_ALERT_GROUPS_SUCCESS: `${prefix}PATCH_ALERT_GROUPS_SUCCESS`,
    PATCH_ALERT_GROUPS_FAIL: `${prefix}PATCH_ALERT_GROUPS_FAIL`,

    POST_ALERT_BY_DATUM_ID_START: `${prefix}POST_ALERT_BY_DATUM_ID_START`,
    POST_ALERT_BY_DATUM_ID_SUCCESS: `${prefix}POST_ALERT_BY_DATUM_ID_SUCCESS`,
    POST_ALERT_BY_DATUM_ID_FAIL: `${prefix}POST_ALERT_BY_DATUM_ID_FAIL`,

    PAUSE_ALERT_START: `${prefix}PAUSE_ALERT_START`,
    PAUSE_ALERT_SUCCESS: `${prefix}PAUSE_ALERT_SUCCESS`,
    PAUSE_ALERT_FAIL: `${prefix}PAUSE_ALERT_FAIL`,

    CLEAR_SAVED_SEARCH: `${prefix}CLEAR_SAVED_SEARCH`,
}
export const createAlertFromDatumIdTypes = {
    start: actionTypes.POST_ALERT_BY_DATUM_ID_START,
    success: actionTypes.POST_ALERT_BY_DATUM_ID_SUCCESS,
    fail: actionTypes.POST_ALERT_BY_DATUM_ID_FAIL,
}

export const getUsersTypes = {
    start: actionTypes.GET_USERS_START,
    success: actionTypes.GET_USERS_SUCCESS,
    fail: actionTypes.GET_USERS_FAIL,
}

export const getAlertTypes = {
    start: actionTypes.GET_ALERT_START,
    success: actionTypes.GET_ALERT_SUCCESS,
    fail: actionTypes.GET_ALERT_FAIL,
}

export const getAlertGroupsTypes = {
    start: actionTypes.GET_ALERT_GROUPS_START,
    success: actionTypes.GET_ALERT_GROUPS_SUCCESS,
    fail: actionTypes.GET_ALERT_GROUPS_FAIL,
}

export const getSavedSearchTypes = {
    start: actionTypes.GET_SAVED_SEARCH_START,
    success: actionTypes.GET_SAVED_SEARCH_SUCCESS,
    fail: actionTypes.GET_SAVED_SEARCH_FAIL,
}

export const postSavedSearchTypes = {
    start: actionTypes.POST_SAVED_SEARCH_START,
    success: actionTypes.POST_SAVED_SEARCH_SUCCESS,
    fail: actionTypes.POST_SAVED_SEARCH_FAIL,
}

export const patchSavedSearchTypes = {
    start: actionTypes.PATCH_SAVED_SEARCH_START,
    success: actionTypes.PATCH_SAVED_SEARCH_SUCCESS,
    fail: actionTypes.PATCH_SAVED_SEARCH_FAIL,
}

export const getSavedSearchEstimatedCountTypes = {
    start: actionTypes.GET_SAVED_SEARCH_ESTIMATED_COUNT_START,
    success: actionTypes.GET_SAVED_SEARCH_ESTIMATED_COUNT_SUCCESS,
    fail: actionTypes.GET_SAVED_SEARCH_ESTIMATED_COUNT_FAIL,
}

export const getAlertBySavedSearchTypes = {
    start: actionTypes.GET_ALERT_BY_SAVED_SEARCH_START,
    success: actionTypes.GET_ALERT_BY_SAVED_SEARCH_SUCCESS,
    fail: actionTypes.GET_ALERT_BY_SAVED_SEARCH_FAIL,
}

export const postAlertTypes = {
    start: actionTypes.POST_ALERT_START,
    success: actionTypes.POST_ALERT_SUCCESS,
    fail: actionTypes.POST_ALERT_FAIL,
}

export const patchAlertTypes = {
    start: actionTypes.PATCH_ALERT_START,
    success: actionTypes.PATCH_ALERT_SUCCESS,
    fail: actionTypes.PATCH_ALERT_FAIL,
}

export const pauseAlertTypes = {
    start: actionTypes.PAUSE_ALERT_START,
    success: actionTypes.PAUSE_ALERT_SUCCESS,
    fail: actionTypes.PAUSE_ALERT_FAIL,
}

export const deleteAlertTypes = {
    start: actionTypes.DELETE_ALERT_START,
    success: actionTypes.DELETE_ALERT_SUCCESS,
    fail: actionTypes.DELETE_ALERT_FAIL,
}

export const getAlertButtonFollowing = {
    start: actionTypes.GET_ALERT_BUTTON_FOLLOWING_START,
    success: actionTypes.GET_ALERT_BUTTON_FOLLOWING_SUCCESS,
    fail: actionTypes.GET_ALERT_BUTTON_FOLLOWING_FAIL,
}

export const postAlertGroupTypes = {
    start: actionTypes.POST_ALERT_GROUPS_START,
    success: actionTypes.POST_ALERT_GROUPS_SUCCESS,
    fail: actionTypes.POST_ALERT_GROUPS_FAIL,
}

export const patchAlertGroupTypes = {
    start: actionTypes.PATCH_ALERT_GROUPS_START,
    success: actionTypes.PATCH_ALERT_GROUPS_SUCCESS,
    fail: actionTypes.PATCH_ALERT_GROUPS_FAIL,
}

export default actionTypes
